export function useCatalogPageBounds(options:any) {
    const read = (value:any) => typeof value === 'function' ? value() : unref(value);
    const check = () => {
        if (read(options.pending)) return;
        const totalPages = read(options.totalPages);
        if (!Number.isFinite(totalPages)) return;
        if (read(options.page) > Math.max(1, Math.ceil(totalPages))) {
            const error = createError({statusCode: 404, message: 'Страница каталога не найдена.'});
            if (import.meta.server) throw error;
            showError(error);
        }
    };
    check();
    // Observe completed query results, rather than testing a new page against stale data.
    watch([...(options.sources || []), () => read(options.pending)], check, {flush: 'post'});
}
